import { useMemo } from 'react';
import { music24OutreachPoolLimit } from 'fym-shared/src/music24/music24Plans';
import { useGetAccountsQuery } from '../../../../redux/api/fymAPI';
import { useUserToken } from '../../../../redux/slices/appInfo/hooks';
import { countOwnArtists } from '../../../accountSelector/demoAccounts';
import { useMusic24Capabilities } from '../../hooks/useMusic24Capabilities';

export interface OutreachMailboxLimit {
  /** The own mailboxes (IMAP and SMTP) of the workspace: per artist on a team plan, pooled. */
  own: number;
}

/**
 * The mailbox limit of the workspace, as music24-api counts them (`readOutreachLimits`): Manager
 * and Label give the own mailboxes for each artist and the workspace pools them. While the artist
 * list loads, the number is the number of one artist.
 */
export function useOutreachMailboxLimit(): OutreachMailboxLimit {
  const capabilities = useMusic24Capabilities();
  const userToken = useUserToken();
  const { accounts } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({ accounts: data?.accounts }),
  });
  return useMemo(
    () => ({
      own: music24OutreachPoolLimit(capabilities, capabilities.outreachMailboxes, countOwnArtists(accounts) ?? 1),
    }),
    [accounts, capabilities]
  );
}
